/**
 * Documents archive — type toggles and row hover.
 *
 * @package HelloElementorChild
 */

var documentsArchiveInstances = new WeakMap();

/** Parametro dei link profondi: ?tipologia=relazioni-di-impatto */
var TYPE_QUERY_VAR = 'tipologia';

/** Gli slug dei termini sono ascii: validarli evita selettori CSS malformati. */
var SLUG_PATTERN = /^[a-z0-9_-]+$/i;

function hasType(root, slug) {
  if (!slug || !SLUG_PATTERN.test(slug)) {
    return false;
  }

  return !!root.querySelector('[data-camst-documents-type="' + slug + '"]');
}

/**
 * Tipologia richiesta dall'indirizzo. Il parametro ?tipologia= è già gestito
 * dal server (il pannello arriva attivo), qui si copre il caso dell'ancora
 * #slug, che al server non arriva mai.
 */
function typeFromLocation(root) {
  try {
    var fromQuery = new URLSearchParams(window.location.search).get(TYPE_QUERY_VAR);

    if (hasType(root, fromQuery)) {
      return fromQuery;
    }

    var fromHash = decodeURIComponent((window.location.hash || '').replace(/^#/, ''));

    return hasType(root, fromHash) ? fromHash : '';
  } catch (error) {
    return '';
  }
}

/**
 * Aggiorna l'indirizzo dopo un click, così la vista corrente è condivisibile.
 * Si usa il parametro e non l'ancora perché il server sa leggere solo il primo,
 * e replaceState non fa scorrere la pagina né sporca la cronologia.
 */
function syncLocation(slug) {
  if (!window.history || !window.history.replaceState || !SLUG_PATTERN.test(slug)) {
    return;
  }

  try {
    var url = new URL(window.location.href);
    url.searchParams.set(TYPE_QUERY_VAR, slug);
    url.hash = '';
    window.history.replaceState(null, '', url.toString());
  } catch (error) {
    /* indirizzo non manipolabile: la selezione funziona comunque */
  }
}

function setActiveType(root, slug) {
  if (!slug) {
    return;
  }

  root.setAttribute('data-active-type', slug);

  root.querySelectorAll('[data-camst-documents-type]').forEach(function (trigger) {
    var isActive = trigger.getAttribute('data-camst-documents-type') === slug;
    trigger.classList.toggle('is-active', isActive);

    if (trigger.getAttribute('role') === 'tab') {
      trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
    }
  });

  root.querySelectorAll('[data-camst-documents-panel]').forEach(function (panel) {
    panel.classList.toggle('is-active', panel.getAttribute('data-camst-documents-panel') === slug);
  });

  root.querySelectorAll('[data-camst-documents-intro-panel]').forEach(function (intro) {
    intro.classList.toggle('is-active', intro.getAttribute('data-camst-documents-intro-panel') === slug);
  });
}

function bindTypeTriggers(root) {
  root.querySelectorAll('[data-camst-documents-type]').forEach(function (trigger) {
    if (trigger.__camstDocumentsBound) {
      return;
    }

    trigger.__camstDocumentsBound = true;

    trigger.addEventListener('click', function () {
      var slug = trigger.getAttribute('data-camst-documents-type');
      setActiveType(root, slug);
      syncLocation(slug);
    });
  });
}

function bindRowHover(root) {
  var list = root.querySelector('.camst-documents-archive__lists');

  if (!list || list.__camstDocumentsHoverBound) {
    return;
  }

  list.__camstDocumentsHoverBound = true;

  list.addEventListener('mouseover', function (event) {
    var row = event.target.closest('[data-camst-documents-row]');

    if (!row || !list.contains(row)) {
      return;
    }

    list.querySelectorAll('[data-camst-documents-row].is-hover').forEach(function (item) {
      item.classList.remove('is-hover');
    });

    row.classList.add('is-hover');
  });

  list.addEventListener('mouseleave', function () {
    list.querySelectorAll('[data-camst-documents-row].is-hover').forEach(function (item) {
      item.classList.remove('is-hover');
    });
  });
}

function initDocumentsArchiveRoot(root) {
  if (!root || documentsArchiveInstances.get(root)) {
    return;
  }

  documentsArchiveInstances.set(root, true);
  bindTypeTriggers(root);
  bindRowHover(root);
  setActiveType(root, typeFromLocation(root) || root.getAttribute('data-active-type'));
}

export function initCamstDocumentsArchive(scope) {
  var roots = [];

  if (!scope) {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-camst-documents-archive]'));
  } else if (scope.matches && scope.matches('[data-camst-documents-archive]')) {
    roots = [scope];
  } else {
    roots = Array.prototype.slice.call(scope.querySelectorAll('[data-camst-documents-archive]'));
  }

  roots.forEach(initDocumentsArchiveRoot);
}

export function teardownCamstDocumentsArchive(root) {
  if (!root) {
    return;
  }

  documentsArchiveInstances.delete(root);

  root.querySelectorAll('[data-camst-documents-type]').forEach(function (trigger) {
    trigger.__camstDocumentsBound = false;
  });

  var list = root.querySelector('.camst-documents-archive__lists');

  if (list) {
    list.__camstDocumentsHoverBound = false;
  }
}
